var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"linkedin"},[_c('main',{staticClass:"main",class:{ 'expand-main' : _vm.isMenuCollapse }},[_c('Captaindata',{key:_vm.keyLinkedin,on:{"refresh":_vm.refreshLinkedin}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }